module.exports = __webpack_public_path__ + "img/closeIlustration.da961980.png";